import React from "react";

import adjustPrice from "../../../Utils/AdjustPrice";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";
import { getProductType } from "../../../Utils";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "moment";
import defaultImage from "../../../Images/Images/default-image.webp";
import useCanSeePrices from "../../../hooks/useCanSeePrices";

function OrderProductItem({ packing, realDeliveryDate }) {
  const { t, i18n } = useTranslation("common");
  const { language } = i18n;
  const { user } = useSelector((state) => state.userReducer);
  const canSeePrices = useCanSeePrices();
  // const [packingStock, setpackingStock] = useState();

  // The store's view (no container name), its commercial's too.
  const isReseller = [0, 7].includes(user?.attributes?.userRole);
  const isDelivered = moment(realDeliveryDate)?.diff(moment(), "day") < 0;
  const isArrived = (packing) =>
    moment(packing?.approvisionnement?.arrivalDate)?.diff(moment(), "day") < 0;

  const totalDiscount = (currentPacking) =>
    (currentPacking?.discount || 0) + (currentPacking?.globalDiscount || 0);

  const groupedPackings = packing?.packings?.reduce((acc, curr) => {
    let key = null;
    if (isArrived(curr)) {
      key = `In stock ${
        !isReseller ? `- ${curr?.approvisionnement?.containerName}` : ""
      }`;
    } else if (packing?.approvisionnement?.arrivalDate) {
      key = `Appro ${
        !isReseller ? curr?.approvisionnement?.containerName || "" : ""
      } Arrive on ${moment(packing?.approvisionnement?.arrivalDate)?.format(
        "D/M/YYYY",
      )}`;
    } else {
      key = `Appro ${
        !isReseller ? curr?.approvisionnement?.containerName || "" : ""
      } Estimated on ${moment(
        packing?.approvisionnement?.estimatedDate,
      )?.format("D/M/YYYY")}`;
    }
    if (acc[key]) {
      acc[key].push(curr);
    } else {
      acc[key] = [curr];
    }
    return acc;
  }, {});

  // useEffect(() => {
  //   moment(packing?.approvisionnement?.arrivalDate)?.diff(moment(), "day") < 0
  //     ? setpackingStock(t("In stock"))
  //     : packing?.approvisionnement?.arrivalDate
  //     ? setpackingStock(
  //         `${t("In supply on")} ${moment(
  //           packing?.approvisionnement?.arrivalDate
  //         )?.format("D/M/YYYY")}`
  //       )
  //     : setpackingStock();
  // }, [packing?.approvisionnement?.arrivalDate, t]);

  return (
    <>
      <div className="row gx-0 px-5 py-3 alignH">
        <div className={`col-3 px-0 alignH`}>
          <div className="overflow-hidden col-1 me-2" style={{ width: "90px" }}>
            <img
              src={
                packing.mainImageURL
                  ? `${IMAGE_END_POINT}${packing.mainImageURL}`
                  : defaultImage
              }
              alt="product"
              style={{ width: "90px" }}
              className={`${
                packing.mainImageURL ? "" : "object-cover scale-3-50"
              } br10`}
            />
          </div>
          <div className={`normal px-0 f14 text-brightGrey me-3`}>
            <p className="my-0">
              {language === "en"
                ? (packing.productName_en ?? packing.productName) ||
                  packing?.name
                : ((packing.productName || packing?.name) ?? "-")}
            </p>

            <div className="ms-auto pe-5">
              {packing.cuve || packing.panel ? (
                <div className="f12 px-0 text-brightGrey">
                  {t(`${packing.cuve}`)} / {t(`${packing.panel}`)}
                </div>
              ) : null}
            </div>
            {getProductType(packing?.productType, t) !== "Services" &&
              !isDelivered && (
                <div
                  className="text-blue f12 bold cursor-pointer"
                  // ref={target}
                  // onMouseOver={() => setShowOverlay(true)}
                  // onMouseOut={() => setShowOverlay(false)}
                >
                  {/* {t("Availability")} */}
                  <div className="d-flex flex-column mt-2 gap-1">
                    {Object.values(groupedPackings)?.map((packings) => {
                      if (!packings?.length > 0) return null;
                      const p = packings[0];
                      return (
                        <p className="text-dark f12 sBold cursor-pointer mb-0">
                          <span className="bold">
                            {isDelivered ? (
                              t("Delivered")
                            ) : isArrived(p) ? (
                              <span className="text-green">
                                {`${packings?.length} `}
                                {t("In stock")}
                                {!isReseller
                                  ? ` - ${p?.approvisionnement?.containerName}`
                                  : ""}
                              </span>
                            ) : p?.approvisionnement?.arrivalDate ? (
                              <span className="text-blue">
                                {`${packings?.length} `}
                                {`${t("In supply")} ${
                                  !isReseller
                                    ? p?.approvisionnement?.containerName || ""
                                    : ""
                                }, ${t("will arrive on")} ${moment(
                                  packing?.approvisionnement?.arrivalDate,
                                )?.format("D/M/YYYY")}`}
                              </span>
                            ) : (
                              <span className="text-blue">
                                {`${packings?.length} `}
                                {`${t("In supply")} ${
                                  !isReseller
                                    ? p?.approvisionnement?.containerName || ""
                                    : ""
                                }, ${t("Estimated on")} ${moment(
                                  packing?.approvisionnement?.estimatedDate,
                                )?.format("D/M/YYYY")}`}
                              </span>
                            )}
                          </span>
                        </p>
                      );
                    })}
                  </div>
                </div>
              )}
          </div>
        </div>

        <span className={`col-1 normal f14 px-0 text-brightGrey `}>
          {packing.reference ?? "-"}
        </span>
        <div className="d-flex flex-column col-2">
          {packing?.packings?.map(({ refClient }, i) => (
            <span className={`normal f14 px-0 text-brightGrey `}>
              {refClient || "-"}
            </span>
          ))}
        </div>
        <span className={`col-2 normal px-0 f14 text-brightGrey`}>
          {packing?.packings?.map(({ serialNumber }, i) => {
            return (
              <div className="d-flex flex-wrap" key={i}>
                <span className="text-break pe-2">{serialNumber} </span>
              </div>
            );
          }) || "-"}
        </span>
        <span className={`col-1 normal f14 px-0 text-brightGrey `}>
          {packing.numberOfProducts}
        </span>
        {canSeePrices && (
          <>
            <span className={` normal col-1 px-0 f14 text-brightGrey textNoWrap`}>
              {totalDiscount(packing)
                ? adjustPrice(
                    packing?.packings
                      ?.reduce((acc, curr) => acc + totalDiscount(curr), 0)
                      ?.toFixed(2)
                      ?.toString() || 0,
                  ) + " €"
                : "-"}{" "}
            </span>
            <div className={`my-0 col-1 d-flex flex-column`}>
              {totalDiscount(packing) !== null && totalDiscount(packing) !== 0 && (
                <span
                  className={`text-decoration-line-through normal f14 px-0 text-brightGrey textNoWrap`}
                >
                  {adjustPrice(packing.unitPrice?.toFixed(2)?.toString() || 0)} €
                </span>
              )}
              <span className={`col-1 normal f14 px-0 text-brightGrey textNoWrap`}>
                {adjustPrice(
                  (packing?.numberOfProducts > 1 && packing?.productType !== 1
                    ? packing.unitPrice - totalDiscount(packing)
                    : packing?.packings?.reduce(
                        (acc, curr) =>
                          acc + (curr?.soldPrice - totalDiscount(curr)),
                        0,
                      ) / packing?.numberOfProducts
                  )
                    ?.toFixed(2)
                    ?.toString() || 0,
                )}{" "}
                €
              </span>
            </div>

            <span className={`col-1 normal f14 px-0 text-brightGrey textNoWrap`}>
              {adjustPrice(
                (packing?.numberOfProducts > 1 && packing?.productType !== 1
                  ? (packing.unitPrice - totalDiscount(packing)) *
                    packing.numberOfProducts
                  : packing?.packings?.reduce(
                      (acc, curr) => acc + (curr?.soldPrice - totalDiscount(curr)),
                      0,
                    )
                )
                  .toFixed(2)
                  ?.toString() || 0,
              )}{" "}
              €
            </span>
          </>
        )}
      </div>
      <hr
        style={{
          border: `1px solid white`,
          opacity: 0.8,
          width: "97%",
          margin: "0.5rem auto ",
        }}
      />
    </>
  );
}

export default OrderProductItem;
